'use client'

import { cn } from '@/lib/utils'

export type DeveloperTab = 'overview' | 'cli' | 'api' | 'mcp' | 'logs'

const TABS: Array<{ id: DeveloperTab; label: string }> = [
  { id: 'overview', label: 'Container' },
  { id: 'cli', label: 'CLI' },
  { id: 'api', label: 'API' },
  { id: 'mcp', label: 'MCP' },
  { id: 'logs', label: 'Logs' },
]

type Props = {
  active: DeveloperTab
  onChange: (tab: DeveloperTab) => void
}

export function DeveloperSubNav({ active, onChange }: Props) {
  return (
    <nav
      role="tablist"
      aria-label="Developer sections"
      className="inline-flex items-center gap-1 rounded-[12px] border-[0.5px] border-line bg-surface p-1"
    >
      {TABS.map((tab) => {
        const isActive = active === tab.id
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={cn(
              'inline-flex h-8 items-center rounded-lg px-3 text-sm font-medium transition-colors',
              isActive
                ? 'bg-atrium-content text-atrium-black'
                : 'text-atrium-black/60 hover:bg-atrium-content hover:text-atrium-black',
            )}
          >
            {tab.label}
          </button>
        )
      })}
    </nav>
  )
}

export function developerTabLabel(tab: DeveloperTab): string {
  return TABS.find((item) => item.id === tab)?.label ?? 'Container'
}
